import cn from 'classnames';
import React, { ComponentPropsWithoutRef, useRef } from 'react';

import { useIsOverflow } from '../../utils/useIsOverlow';
import { useWindowSize } from '../../utils/useWindowSize';
import classes from './CustomModal.module.scss';

type TBodyProps = ComponentPropsWithoutRef<'div'> & {
  centered?: boolean
};

export function Body({
  centered,
  className,
  children,
  ...props
}: TBodyProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { height } = useWindowSize();
  const isOverflowing = useIsOverflow(ref, [height]);

  return (
    <div
      ref={ref}
      className={cn(
        classes['custom-modal__body'],
        {
          [classes['custom-modal__body--centered']]: centered,
          [classes['custom-modal__body--overflowing']]: isOverflowing,
        },
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
